import styles from './ModalBrConsorcio.module.css';
import Modal from 'react-responsive-modal';
import alert from '../../../../assets/images/alert.png';
import { Button } from '../../../../components/Button';

interface IModalBrConsorcio {
  modalIsOpen: boolean;
  toggleModal: () => void;
  handleForm: (
    e?: React.BaseSyntheticEvent<object, any, any> | undefined
  ) => Promise<void>;
}

export function ModalBrConsorcio({
  modalIsOpen,
  toggleModal,
  handleForm,
}: IModalBrConsorcio) {
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={alert} alt="" />
        </div>
        <h1 className="title-modal">Aviso</h1>
        <b className="subtitle-modal">
          Não serão aceitos como Indicadores de Negócio:
        </b>
        <ul>
          <li>Pessoas com menos de 18 anos de idade;</li>
          <li>Colaboradores da BR Consórcios; </li>
          <li>
            Parentes em primeiro grau (cônjuges, filhos ou pais) de vendedores
            da BR Consórcios.
          </li>
        </ul>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Estou ciente"
          type="button"
          color="primary"
          onClick={() => {
            toggleModal();
            handleForm();
          }}
        />
      </div>
    </Modal>
  );
}
